import script from "./zclb.vue?vue&type=script&setup=true&lang=js"
export * from "./zclb.vue?vue&type=script&setup=true&lang=js"

import "./zclb.vue?vue&type=style&index=0&id=b18f7344&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b18f7344"]])

export default __exports__